<template>
  <div class="nav">
    <img class="logo" src="" alt="logo"/>
    <ul class="nav-header">
      <li><a>导航导航</a></li>
      <li><a>导航导航</a></li>
      <li><a>导航导航</a></li>
      <li><a>导航导航</a></li>
      <li><a>导航导航</a></li>
      <li><a>导航导航</a></li>
      <li><a>导航导航</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>


<style lang='scss'  scoped>
.nav{
  display: flex;
}
.logo{
  height: 50px;
  width: 254px;
  display: block;
  margin: 20px 100px 0 0;
  background: #ccc;
}
.nav-header{
  display: flex;
  font-size: 15px;
  font-weight: bold;
  a{
    padding: 33px 10px;
    display: block;
    color: #000;
  }
}
</style>
